<template>
  <div class="bg-stand">
    <top-header></top-header>
    <div class="container-fluid">
      <div class="col-12">
        <div class="row top-navbar">
          <div class="col-6 pl-0">
            <h6 class="mb-2">All Users</h6>
            <p class="m-0 d-flex align-items-center flex-row">
              <img src="@/assets/Users.svg" width="20px" height="18px" /> <span class="ml-2">{{ count }} <template
                  v-if="count > 1">users</template><template v-else>user</template></span>
            </p>
          </div>
          <div class="col-6 pr-0 d-flex flex-row justify-content-end">
            <span class="user-search-icons" style="position: relative;">
              <input type="text" placeholder="Search User" @input="searchuser" class="serach-user-box" />
              <img src="@/assets/SearchBar.svg" class="search-bar-icon" />
            </span>
            <span class="add-user-btn ml-3" @click="adduser">
              <img src="@/assets/Plus.svg" />&nbsp;
              Add User
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid user-list-cover">
      <div class="users-list p-4">
        <div class="row mb-3">
          <div class="col-6">
            <span class="user-status-btn mr-1" :class="{ 'active': current_tab == 'All Users' }"
              @click="tab('All Users')">
              All Users
            </span>
            <span class="user-status-btn mr-1" :class="{ 'active': current_tab == 'Blocked Users' }"
              @click="tab('Blocked Users')">
              Blocked
            </span>
            <span class="user-status-btn mr-1" :class="{ 'active': current_tab == 'Active Users' }"
              @click="tab('Active Users')">
              Active
            </span>
            <span class="user-status-btn" :class="{ 'active': current_tab == 'Archived Users' }"
              @click="tab('Archived Users')">
              Archived
            </span>
            <span class="user-status-btn" :class="{ 'active': current_tab == 'Company Guest Users' }"
              @click="tab('Company Guest Users')">
              Company Guest Users
            </span>
          </div>
          <div class="col-6 d-flex justify-content-end flex-row">
            <span class="viewtype" :class="{ 'active': viewtype == 'grid' }" @click="set_viewtype('grid')">
              <img src="@/assets/grid.svg" width="16px" height="16px" v-if="viewtype != 'grid'" />
              <img src="@/assets/grid - blue.svg" width="16px" height="16px" v-if="viewtype == 'grid'" />
            </span>
            <span class="viewtype ml-3" :class="{ 'active': viewtype == 'list' }" @click="set_viewtype('list')">
              <img src="@/assets/List.svg" width="16px" height="16px" v-if="viewtype != 'list'" />
              <img src="@/assets/List - Blue.svg" width="16px" height="16px" v-if="viewtype == 'list'" />
            </span>
          </div>
        </div>
        <div class="row loader" v-if="!users.length">
          <div class="col-12 d-flex justify-content-center align-items-center still-loading" v-if="!found">
            <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
              preserveAspectRatio="xMidYMid" class="lds-dual-ring"
              style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
              <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
                stroke-dasharray="31.41592653589793 31.41592653589793">
                <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                  keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
              </circle>
            </svg>
            Loading users...
          </div>
          <div class="col-12 no-found d-flex justify-content-center align-items-center" v-if="found">
            <p>{{ user_length_text }}</p>
          </div>
        </div>
        <div class="user-grid" v-if="users.length && viewtype == 'grid'">
          <div class="grid-user-box mr-3 text-center" v-for="(user, index) in users" :key="index">
            <div class="photo">
              <template v-if="user.data.photo">
                <span class="default-pic" @click="showprofile(user, index)">
                  <img :src=getPhoto(user.data.photo) class="img-fluid" />
                </span>
              </template>
              <template v-if="!user.data.photo">
                <span @click="showprofile(user, index)" class="default-pic">{{ getName(user.names) }}</span>
              </template>
              <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'BLOCKED'"
                :class="{ 'blocked': !user.data.isActive && user.data.access_status == 'BLOCKED' }">Blocked</span>
              <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'ARCHIVED'"
                :class="{ 'archived': !user.data.isActive && user.data.access_status == 'ARCHIVED' }">Archived</span>
              <span class="user-badge" v-if="user.data.isActive" :class="{ 'active': user.data.isActive }">Active</span>
              <span class="user-badge" v-if="user.access_status === 'GUEST'"
                :class="{ 'active': user.access_status === 'GUEST' }">Guest</span>
            </div>
            <span class="edit-pen" @click="edit_user(index)">
              <template v-if="user.access_status !== 'GUEST'">
                <img src="@/assets/Edit-User-Pen.svg" width="16px" height="16px" />
              </template>
            </span>
            <div class="name">
              <h4 @click="showprofile(user, index)" class="profile-name text-center">{{ user.names }} <span
                  v-if="user.isSuperAdmin">(Admin)</span></h4>
            </div>
            <p class="dept">
              {{ user.department }}
            </p>
            <div class="stat">
              <p>
                <img src="@/assets/Calendar-Light.svg" width="16px" height="16px" />&nbsp;
                <span>{{ format(user.data.createdAt) }}</span>
              </p>
              <p v-if="user.access_status !== 'GUEST'">
                <img src="@/assets/Storage.svg" width="16px" height="16px" />
                <span class="text" v-if="user.storage == 'Unlimited'">&nbsp;{{ user.storage }}</span>
                <span class="text" v-if="user.storage != 'Unlimited'">&nbsp;{{ $sizeFormat(user.storage) }}</span>
              </p>
            </div>
            <div class="user-atn-btn" v-if="user.data.isActive || user.data.access_status == 'BLOCKED'">
              <span v-if="!user.data.isActive" @click="unblockuser(index, user.data._id, user.names)">
                <img src="@/assets/Unblock-User.svg" width="18px" height="16px" />
                &nbsp;
                <span>Unblock</span>
              </span>
              <span v-if="user.data.isActive" @click="blockuser(index, user.data._id, user.names)">
                <img src="@/assets/Delete-User.svg" width="18px" height="16px" />
                &nbsp;
                <span>Block</span>
              </span>
              <span @click="delete_user(user.data._id, user.names, index)">
                <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" />
                &nbsp;
                <span>Delete</span>
              </span>
            </div>
            <template v-if="user.access_status === 'GUEST'">
              <div class="user-atn-btn" v-if="user.access_status == 'GUEST'">
                <span>
                  <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" />&nbsp;
                  <span>Remove Guest</span>
                </span>
              </div>
            </template>
          </div>
        </div>
        <div class="row users-table" v-if="users.length && viewtype == 'list'">
          <div class="col-12 mt-4">
            <div class="group-folders">
              <ul v-if="users.length">
                <li v-for="(user, index) in users" :key="index" class="row">
                  <div class="col-3 d-flex align-items-center">
                    <template v-if="user.data.photo">
                      <span class="default-pic" @click="showprofile(user, index)">
                        <img :src=getPhoto(user.data.photo) class="img-fluid" />
                      </span>
                    </template>
                    <template v-if="!user.data.photo">
                      <span @click="showprofile(user, index)" class="profile-pic">
                        <span class="default-pic">{{ getName(user.names) }}</span>
                      </span>
                    </template>&nbsp;&nbsp;
                    <span class="text-size">{{ user.names }}</span>
                  </div>
                  <div class="col-2 d-flex align-items-center">
                    <span class="text-size">{{ user.department }}</span>
                  </div>
                  <div class="col-2 d-flex align-items-center">
                    <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'BLOCKED'"
                      :class="{ 'blocked': !user.data.isActive && user.data.access_status == 'BLOCKED' }">Blocked</span>
                    <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'ARCHIVED'"
                      :class="{ 'archived': !user.data.isActive && user.data.access_status == 'ARCHIVED' }">Archived</span>
                    <span class="user-badge" v-if="user.data.isActive"
                      :class="{ 'active': user.data.isActive }">Active</span>
                    <span class="user-badge" v-if="user.access_status === 'GUEST'"
                      :class="{ 'active': user.data.isActive }">Guest</span>
                  </div>
                  <div class="col-2 d-flex align-items-center">
                    <img src="@/assets/Calendar-Light.svg" />&nbsp;
                    {{ format(user.data.created_at) }}
                  </div>
                  <div class="actions col-2 d-flex align-items-center">
                    <img src="@/assets/Storage.svg" />
                    <span class="text" v-if="user.storage == 'Unlimited'">&nbsp;{{ user.storage }}</span>
                    <span class="text" v-if="user.storage != 'Unlimited'">&nbsp;{{ $sizeFormat(user.storage) }}</span>
                  </div>
                  <div class="col-1 text-left d-flex align-items-center justify-content-end" style="position: relative">
                    <template v-if="user.data.isActive || user.data.access_status == 'BLOCKED'">
                      <img src="@/assets/vertical.svg" style="cursor:pointer" @click="showdropdown(index)" />
                      <div class="user-dropdown" v-if="user.dropdown" v-on-clickaway="closeDropdown">
                        <user-dropdown ref="userdropdown" :data="{ data: user, index: index }"></user-dropdown>
                      </div>
                    </template>
                    <template v-if="user.access_status == 'GUEST'">
                      <img src="@/assets/vertical.svg" style="cursor:pointer" @click="showdropdown(index)" />
                      <div class="user-dropdown" v-if="user.dropdown" v-on-clickaway="closeDropdown">
                        <user-dropdown ref="userdropdown" :data="{ data: user, index: index }"></user-dropdown>
                      </div>
                    </template>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <embeded ref="embeded"></embeded>
    <login ref="login"></login>
    <blockuserprompt ref="blockuserprompt"></blockuserprompt>
    <unblockuserprompt ref="unblockuserprompt"></unblockuserprompt>
    <useradded ref="useradded"></useradded>
    <useredited ref="useredited"></useredited>
    <logout ref="logout"></logout>
    <adduser ref="adduser"></adduser>
    <showprofile ref="showprofile"></showprofile>
    <deleteuser ref="delete"></deleteuser>
    <warninglog ref="warninglog"></warninglog>
    <edituser ref="edituser"></edituser>
    <notify ref="notify"></notify>
    <loading ref="loading"></loading>
    <invite ref="invite"></invite>
  </div>
</template>
<style scoped>
.user-grid {
  overflow-x: hidden;
}

.user-dropdown {
  position: absolute;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 5px 12px rgba(178, 189, 211, 0.21);
  top: 10px;
  right: 0;
  width: 180px;
  z-index: 1000;
}

.user-table .user-badge.blocked {
  background-color: #FFEBEB;
  color: #FC6D6C;
  right: 10px;
}

.user-table .user-badge.archived {
  background-color: #E8F0F6;
  color: #677888;
  right: 6px;
}

.user-table .user-badge.active {
  background-color: #E2F8EC;
  color: #40D886;
  right: 15px;
}

.user-table .user-badge {
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 4px;
  position: absolute;
  bottom: -18px;
}

.users-list .row:first-child {
  height: auto !important;
}

.group-folders ul li {
  background: #fff;
  padding: 1em;
  border-radius: 8px;
  margin-bottom: 12px;
}

.create-file {
  top: 0;
}

.bg-stand {
  height: 100%;
}

.default-pic {
  cursor: pointer;
  background: #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #71809a;
  width: 48px;
  height: 48px;
  font-size: 1.125rem;
  font-weight: bold;
}

.all-users {
  position: relative;
}

.bottom-pane {
  height: 50px;
}

.bottom-pane .btn-add {
  padding-top: .5em !important;
  padding-bottom: .5em !important;
}

.count {
  position: absolute;
  right: 0;
  background: #0071E0;
  font-size: 12px;
  font-weight: 800;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  color: #fff;

}

.setup-account {
  height: 100%;
}

.not-found {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.users-not-found {
  background: #fafafa;
  height: calc(100% - 125px);
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.users-list {
  background: #fafafa;
  height: calc(100% - 125px);
  text-align: left;
  padding-top: 1em;
}

.users-list .card .photo,
.users-list .card .name {
  display: flex;
  justify-content: center;
  align-items: center;
}

.users-list .card .name {
  font-weight: bold;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
  margin: 1em 0;
}

.form .btn {
  cursor: pointer;
  background: #0071E0;
  color: #fff;
  border-radius: 3px;
  padding: 1.2em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.bottom-pane .btn {
  cursor: pointer;
  background: #0071E0;
  color: #fff;
  border-radius: 50px;
  padding: .6em 1em;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  margin-right: 6em;
}

.bottom-pane h1 {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.bottom-pane {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-pane div {
  display: flex;
  align-items: center;
}

.bottom-pane div span:last-child {
  margin-left: 1em;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
}

.user {
  margin-bottom: 1em;
}
</style>

<script>

import logout from '@/components/Logout'
import TopHeader from '@/components/Top-Header'
import moment from 'moment'
import login from '@/components/Login'
import cookies from '@/services/cookies'
import loading from '@/components/Loading'
import blockuserprompt from '@/components/Block-User-Prompt'
import unblockuserprompt from '@/components/Unblock-User-Prompt'
import edituser from '@/components/Edit-User'
import adduser from '@/components/Add-User'
import useradded from '@/components/User-Added'
import useredited from '@/components/User-Edited'
import showprofile from '@/components/Show-Profile'
import deleteuser from '@/components/Delete-User'
import warninglog from '@/components/WarningLog'
import notify from '@/components/Notify'
import embeded from '@/components/Embed'
import { directive as onClickaway } from 'vue-clickaway'
import { mapMutations } from 'vuex'
import UserDropdown from '@/components/User-Dropdown'
import invite from '@/components/Invite'
export default {
  components: {
    warninglog,
    deleteuser,
    edituser,
    useredited,
    loading,
    logout,
    login,
    notify,
    adduser,
    useradded,
    blockuserprompt,
    unblockuserprompt,
    showprofile,
    embeded,
    TopHeader,
    invite,
    UserDropdown
  },
  data() {
    return {
      answer: '',
      current_tab: 'All Users',
      error: {
        answer: false,
        message: false
      },
      departments: [],
      name: '',
      post: true,
      users: [],
      stored_users: [],
      count: 0,
      found: true,
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      department: localStorage.getItem('department'),
      position: localStorage.getItem('position'),
      account_type: localStorage.getItem('account_type'),
      total_current_users: 0,
      current_users: 0,
      is_subscription_active: false,
      is_trial: false,
      is_trial_expired: false,
      user_length_text: 'No user added yet...',
      viewtype: 'grid',
      backendUrl: this.$store.getters.BACKENDURL,
      dropdown: false,
      dropdown_index: null
    }
  },
  methods: {
    invite() {
      this.$refs.invite.load();
    },
    closeDropdown() {
      if (this.dropdown_index != null) {
        this.users[this.dropdown_index].dropdown = false
        this.dropdown_index = null
      }
    },
    showdropdown(index) {
      if (this.dropdown_index != null) {
        this.users[this.dropdown_index].dropdown = false
      }

      this.dropdown_index = index
      this.users[index].dropdown = !this.users[index].dropdown
    },
    close_drop_down(index) {
      this.users[index].dropdown = false
    },
    getPhoto(url) {
      return `${this.backendUrl}/static-photos/${url}`
    },
    set_viewtype(type) {
      this.viewtype = type
    },
    getName(name) {
      return name[0]
    },
    notify(msg) {
      this.$refs.notify.load(msg)
    },
    warninglog(file, name, index, id) {
      this.$refs.warninglog.load(file, name, index, id)
    },
    delete_user(id, name, index) {
      this.$refs.delete.load(id, name, index)
    },
    archiveuserloader() {
      this.$refs.loading.load()
    },
    closearchiveuserloader() {
      this.$refs.loading.close()
    },
    deleteuserloader() {
      this.$refs.loading.load()
    },
    closedeleteuserloader() {
      this.$refs.loading.close()
    },
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'GET_DIRECTORY_CHILDREN',
      'CLOSE_FILE_INFO',
      'SET_PATH',
      'UPDATE_SLIDEIN',
      'UPDATE_SLIDEOUT',
      'UPDATE_BODY_MENU',
      'UPDATE_MENU',
      'UPDATE_TOTAL_CREATED_IMAGES',
      'UPDATE_TOTAL_CREATED_DOCUMENTS',
      'UPDATE_TOTAL_CREATED_FOLDERS',
      'SET_FIRSTNAME',
      'SET_LASTNAME',
      'SET_EMAIL',
      'SET_PHONE',
      'SET_POSITION',
      'SET_DEPARTMENT',
      'SET_COUNTRY',
      'SET_DATE_CREATED',
      'SET_ACCT_TYPE',
      'SET_ISADMIN',
      'SET_PHOTO',
      'UPDATE_TOTAL_SPACE',
      'UPDATE_DEFAULT_FOLDER',
      'UPDATE_TOTAL_USED_SPACE',
      'SET_ISTRIAL',
      'SET_ISSTAFF',
      'SET_ISSUPERADMIN',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'HIDE_FILE_INFO',
      'SET_FILE_ACTION',
      'SET_SELECT_ALL',
      'SET_USER_PLAN',
      'UPDATE_USER',
      'SET_CURRENT_PLAN',
      'UPDATE_PUBLIC_FOLDER_ID',
      'SET_NAME',
      'SET_IS_SECURITY_QUESTION',
      'SET_PLAN_STATUS',
      'SET_TRIAL_STATUS',
      'SET_REFERRAL_LINK',
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    change_pic() {
      this.UPDATE_SLIDEIN(false)
      this.UPDATE_SLIDEOUT(true)
      this.UPDATE_MENU(false)
      this.UPDATE_BODY_MENU(false)

      this.$refs.pic.click()
    },
    edit_user(index) {
      this.$refs.edituser.load(this.users[index], index)
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0])
      this.$refs.pic.value = ''
    },
    slideout($evt) {
      if ($evt.target.tagName === 'svg' || $evt.target.tagName === 'path') {
        this.UPDATE_SLIDEIN(false)
        this.UPDATE_SLIDEOUT(true)
        this.UPDATE_MENU(false)
        this.UPDATE_BODY_MENU(false)
      } else {
        if ($evt.target.classList.contains('menubody')) {
          this.UPDATE_SLIDEIN(false)
          this.UPDATE_SLIDEOUT(true)
          this.UPDATE_MENU(false)
          this.UPDATE_BODY_MENU(false)
        }
      }
    },
    loading() {
      this.$refs.loading.load()
    },
    closeloader() {
      this.$refs.loading.close()
    },
    showprofile(user, index) {
      this.$refs.showprofile.load(user, index)
    },
    logincall() {
      this.$refs.login.load()
    },
    format(date) {
      return moment(date).format('MMMM D, YYYY')
    },
    time(date) {
      return moment(date).format('h:mm A')
    },
    hideError() {
      this.error.answer = false
    },
    forgot_question() {
      this.$refs.sendquestion.load()
    },
    close() {
      this.error.message = false
    },
    logout() {
      this.$refs.logout.logout()
    },
    adduser() {
      if (this.is_trial) {
        if (this.is_trial_expired) {
          this.$refs.notify.load('Your trial period has elapsed. <br/>Please upgrade to a <a href="/payments-billing">premium plan</a>.')
        } else {
          this.$refs.adduser.load()
        }
      } else {
        if (this.is_subscription_active) {
          if (this.current_users > 0) {
            this.$refs.adduser.load()
          } else {
            this.$refs.notify.load('You have exceed the number of users you can add. <a href="/payments-billing">Buy more users</a>.')
          }
        } else {
          this.$refs.notify.load('Your plan has expired. <br/>Please renew plan to add more users.<br/><a href="/payments-billing">Payments & Billing</a>')
        }
      }
    },
    useradded() {
      this.$refs.useradded.load()
    },
    useredited() {
      this.$refs.useredited.load()
    },
    add_new_user(data, currentUsers) {
      this.current_users = currentUsers
      this.users.push(data)
      // this.stored_users.push(data)
      this.count = this.stored_users.length
    },
    edituser(data, index) {
      this.users[index] = data
      this.$forceUpdate()
    },
    remove_user(index) {
      this.users.splice(index, 1)
      this.count--
    },
    user_data() {
      let data = {
        token: cookies.getCookie('token')
      }

      let that = this

      this.$socket.emit('get-data', data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type)
          that.SET_ISADMIN(data.isSuperAdmin)
          that.SET_FIRSTNAME(data.firstname)
          that.SET_LASTNAME(data.lastname)
          that.SET_NAME(data.firstname + ' ' + data.lastname)
          that.SET_EMAIL(data.email)
          that.SET_PHONE(data.phone)
          that.SET_POSITION(data.position)
          that.SET_DEPARTMENT(data.department)
          that.SET_COUNTRY(data.country ? data.country : '')
          that.SET_DATE_CREATED(data.date_created)
          that.SET_PHOTO(data.photo)
          that.UPDATE_TOTAL_SPACE(data.total_space)
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used)
          that.UPDATE_USER(data.id)
          that.SET_CURRENT_PLAN(data.current_plan)
          that.SET_USER_PLAN(data.user_plan)
          that.SET_REFERRAL_LINK(data.referral_link)
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_PLAN_STATUS(data.isPlanActive)
          that.SET_TRIAL_STATUS(data.isTrialActive)

          that.SET_ISTRIAL(data.isTrial)
          that.SET_ISSTAFF(data.isStaff)
          that.SET_ISSUPERADMIN(data.isSuperAdmin)

          that.SET_IS_SECURITY_QUESTION(data.is_security_question)

          that.UPDATE_DEFAULT_FOLDER(data.default_folders)

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id)

          localStorage.setItem('email', data.email)
          localStorage.setItem('is_security_question', data.is_security_question)
          sessionStorage.setItem('gi', data.group_folder_id)
          sessionStorage.setItem('pi', data.project_folder_id)

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images)
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents)
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders)
        } else {
          that.$router.push('/login')
        }
      })
    },
    all_users() {
      this.users = this.stored_users
      if (this.users.length) {
        this.user_length_text = 'No users added yet'
      }
    },
    active_users() {
      let users = this.stored_users.filter(user => {
        if (user.data.isActive) {
          return user
        }
      })

      if (users.length === 0) {
        this.user_length_text = 'No Active users'
      }
      this.users = users
    },
    blocked_users() {
      let users = this.stored_users.filter(user => {
        if (!user.data.isActive && user.data.access_status === 'BLOCKED') {
          return user
        }
      })

      if (users.length === 0) {
        this.user_length_text = 'No blocked users'
      }
      this.users = users
    },
    archived_users() {
      let users = this.stored_users.filter(user => {
        if (!user.data.isActive && user.data.access_status === 'ARCHIVED') {
          return user
        }
      })

      if (users.length === 0) {
        this.user_length_text = 'No archived users'
      }
      this.users = users
    },
    guest_users() {
      let users = this.stored_users.filter(user => {
        console.log(user.access_status)
        if (user.access_status === 'GUEST') {
          return user
        }
      })

      if (users.length === 0) {
        this.user_length_text = 'No guest users'
      }

      console.log(users)
      this.users = users
    },
    tab(tab) {
      this.current_tab = tab
      if (tab === 'All Users') {
        this.all_users()
      }

      if (tab === 'Active Users') {
        this.active_users()
      }

      if (tab === 'Blocked Users') {
        this.blocked_users()
      }

      if (tab === 'Archived Users') {
        this.archived_users()
      }

      if (tab === 'Company Guest Users') {
        this.guest_users()
      }
    },
    blockuser(index, id, names) {
      this.$refs.blockuserprompt.load(index, id, names)
    },
    unblockuser(index, id, names) {
      this.$refs.unblockuserprompt.load(index, id, names)
    },
    updateBlock(index, type) {
      if (type) {
        this.users[index].data.isActive = true
        this.users[index].data.access_status = 'ACTIVE'
      } else {
        this.users[index].data.isActive = false
        this.users[index].data.access_status = 'BLOCKED'
      }

      this.$forceUpdate()
    },
    searchuser(evt) {
      if (evt.target.value) {
        let data = JSON.parse(JSON.stringify(this.stored_users))
        this.users = data.filter(function (user) {
          return user.names.toLowerCase().includes(evt.target.value.toLowerCase())
        })
      } else {
        this.users = this.stored_users
      }
    }
  },
  directives: {
    onClickaway: onClickaway
  },
  mounted() {
    this.user_data()
    let app = document.querySelector('#app')
    app.style.height = '100%'
    app.style.overflowY = 'hidden'

    let that = this
    if (cookies.getCookie('token') !== '' && cookies.getCookie('token') !== null) {
      let data = {
        token: cookies.getCookie('token')
      }

      this.$socket.emit('auth', data, (data) => {
        if (data.data === false) {
          that.$router.push('/login')
        } else {
          that.name = data.name
          that.is_subscription_active = data.is_subscription_active
          that.is_trial = data.is_trial
          that.total_current_users = data.total_current_users
          that.current_users = data.current_users
          that.is_trial_expired = data.has_trial_expired

          that.$socket.emit('get-users', { token: cookies.getCookie('token') }, function (data) {
            console.log(data.users)
            if (data.data === true) {
              that.users = data.users
              that.stored_users = data.users
              that.count = data.users.length
              if (that.count > 0) {
                that.found = true
              }
            }
          })
        }
      })
    } else {
      this.$router.push('/login')
    }
  }
}
</script>
